class LoyaltyMessages extends window.BAO.CustomElement() {
  constructor () {
    super()

    this.currentIndex = 0
    this.delay = 3000
  }

  setupListeners () {
    super.setupListeners()

    this.showMessage = this.showMessage.bind(this)

    this.showMessage()
  }

  showMessage () {
    if (this.currentIndex < this.els.item.elements.length) {
      this.els.item.elements[this.currentIndex].setAttribute(
        'aria-hidden',
        false,
      )

      setTimeout(() => {
        this.els.typing.elements[this.currentIndex].setAttribute(
          'aria-hidden',
          true,
        )
        this.els.message.elements[this.currentIndex].setAttribute(
          'aria-hidden',
          false,
        )
      }, this.delay / 2)

      setTimeout(() => {
        this.currentIndex++

        this.showMessage()
      }, this.delay)
    }
  }
}

if (!customElements.get('loyalty-messages')) {
  customElements.define('loyalty-messages', LoyaltyMessages)
}
